import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Root, Puller, Header, ContentWrapper, Action } from "./swipeable-drawer.styles.js";
import "@mui/material";
import "@mui/material/styles";
const SwipeableDrawer = forwardRef(function SwipeableDrawer2({ header, action, children, ...rest }, ref) {
  return /* @__PURE__ */ jsxs(Root, { ref, anchor: "bottom", ...rest, children: [
    /* @__PURE__ */ jsx(Puller, {}),
    header && /* @__PURE__ */ jsx(Header, { children: header }),
    /* @__PURE__ */ jsx(ContentWrapper, { children }),
    action && /* @__PURE__ */ jsx(Action, { children: action })
  ] });
});
export {
  SwipeableDrawer
};
